<template>
  <vue-recaptcha
    ref="refRecaptcha"
    :sitekey="siteKey"
    :load-recaptcha-script="true"
    @verify="handleSuccess"
    @expired="handleExpired"
    @error="handleError">
  </vue-recaptcha>
</template>

<script>
import { ref, computed } from 'vue'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha
  },
  setup: (props, { emit }) => {
    const refRecaptcha = ref(null)
    const siteKey = computed(() => {
      return process.env.VUE_APP_BASE_RECAPTCHA
    })
    const handleSuccess = (response) => {
      emit('response', response, 'success')
    }
    const handleExpired = (response) => {
      emit('response', response, 'expired')
    }
    const handleError = (response) => {
      emit('response', response, 'error')
    }
    const handleReset = () => {
      refRecaptcha.value.reset()
      emit('response', null, 'reset')
    }
    return {
      refRecaptcha,
      siteKey,
      handleSuccess,
      handleExpired,
      handleError,
      handleReset
    }
  }
}
</script>
